export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f38ac6c489de6d82c1833a004b2373d2b278ee3aa&name=fetchTypeahead!'